import { getOptimizedAssetUrl } from './getOptimizedAssetUrl'

interface EmbeddedImageProps {
  title: string
  uri: string
}

export const EmbeddedImage: React.FC<EmbeddedImageProps> = ({ title, uri }) => (
  <img alt={title} className="mx-auto" loading="lazy" src={getOptimizedAssetUrl(uri)} />
)
